import { CustomHTMLEditorParser } from "@whyuz/components";
import { SuccessCaseContentItem } from "@whyuz/services";

export interface SuccessCaseQuestionCardFreeProps {
  question: SuccessCaseContentItem;
}
export const SuccessCaseQuestionCardFree = ({ question }: SuccessCaseQuestionCardFreeProps) => {
  return <div className="p-5">{CustomHTMLEditorParser(question.htmlTextContent || "")}</div>;
};
